import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ChefHat } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email, password); navigate("/"); }
    catch (err) { setError(errMsg(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen bg-[#1B2826]">
      <div className="hidden flex-1 flex-col justify-between p-12 text-slate-200 lg:flex">
        <div className="flex items-center gap-3"><span className="flex h-10 w-10 items-center justify-center rounded-md bg-[#1F5F57] text-white"><ChefHat className="h-6 w-6" /></span><span className="text-xl font-bold text-white">Brigata</span></div>
        <div className="max-w-md fade-up">
          <h1 className="text-4xl font-bold leading-tight text-white">Dalla ricetta al magazzino, un solo flusso.</h1>
          <p className="mt-4 text-base text-slate-300">La ricetta genera il fabbisogno, il fabbisogno genera l'ordine, l'ordine ricevuto aggiorna scorte e costi. Allergeni sempre aggiornati, in cucina e in sala.</p>
        </div>
        <div className="text-xs text-slate-500">Reg. UE 1169/2011 · 14 allergeni · Multi-sede</div>
      </div>
      <div className="flex flex-1 items-center justify-center bg-[#F7F6F2] p-6">
        <form onSubmit={submit} className="card w-full max-w-sm space-y-5 p-6 md:p-8 fade-up" data-testid="login-form">
          <div className="flex items-center gap-2 lg:hidden"><span className="flex h-9 w-9 items-center justify-center rounded-md bg-[#1F5F57] text-white"><ChefHat className="h-5 w-5" /></span><span className="text-lg font-bold">Brigata</span></div>
          <div><h2 className="text-2xl font-bold text-slate-900">Accedi</h2><p className="mt-1 text-sm text-slate-600">Usa le credenziali fornite dall'amministratore.</p></div>
          <div className="space-y-1.5"><Label htmlFor="email">Email</Label><Input id="email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-11 bg-white" data-testid="login-email-input" /></div>
          <div className="space-y-1.5"><Label htmlFor="password">Password</Label><Input id="password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-11 bg-white" data-testid="login-password-input" /></div>
          {error && <p className="rounded-md bg-[#FEE2E2] px-3 py-2 text-sm text-[#7F1D1D]" role="alert" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={busy} className="h-11 w-full" data-testid="login-submit-button">{busy ? "Accesso in corso…" : "Entra"}</Button>
          <p className="text-xs text-slate-500">Password dimenticata? Chiedi all'amministratore di reimpostarla dalla sezione Utenti.</p>
        </form>
      </div>
    </div>
  );
}
